import type {GlobalConfig} from "./types";
import {PageType} from "./types";

export const GLOBAL_CONFIG: GlobalConfig = {
    mainSettings: {
        grade: "Литература. 10 класс",
        subject: "Изучение литературы народов России на углубленном уровне ",
        mainColor: "./images/bg_img.png",
        secondColor: "rgba(250, 219, 187, 0.8)",
    },
    home: {
        title: "Изучение литературы народов России на углубленном уровне ",
        authorsTitle: "Автор",
        authors: [
            {
                author: "Критарова Жанна Николаевна",
                grade: "к.пед.н.",
                subGrade: "старший научный сотрудник лаборатории филологического общего образования ФГБНУ «ИСРО»",
                imageSrc: "./images/author1.png"
            }
        ],
        imagePath: "./images/title_img.png",
    },
    pages: [
        {
            order: 1,
            nextBtnName: "Далее",
            pdfPath: "./files/additional_information.pdf",
            type: PageType.ANNOTATION,
            imagePath: "",
            content: [
                {
                    type: "block",
                    children: [
                        {
                            type: "block",
                            text: "<p style='background: #E7F1FF; border-radius: 16px; padding: 2.4rem;'>Российская Федерация - многонациональное государство. Каждый народ, входящий в её состав, богат своим фольклором и литературой. А литература как искусство слова в наибольшей степени раскрывает духовные ценности народа. </p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>Учебный предмет «Литература» традиционно включает раздел «Литература народов России», который входит в федеральные рабочие программы по литературе основного общего и среднего общего образования.  </p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>В 10 классе на базовом уровне в этот раздел включены стихотворения татарского поэта Габдуллы Тукая и осетинского поэта Коста Хетагурова. Программа предлагает изучение не менее одного произведения по выбору.  </p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>На углубленном уровне обучающимся предстоит дополнительно познакомиться с поэмой Коста Хетагурова «Фатима».  </p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>В чём заключается сложность изучения данной темы? </p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>Во-первых, возникает необходимость выбора, так как в программе названы два поэта, но учитель вправе выбрать и творчество других авторов; во-вторых, может сказаться отсутствие необходимых знаний у преподавателя в области литературы народов России; в-третьих, на изучение предложенных произведений на базовом уровне отводится только один час.  </p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>На изучение данной темы в 10 классе на углубленном уровне добавляется ещё один час из общего количества резервных часов, что нашло отражение в поурочном планировании, размещённом в конструкторе рабочих программ по литературе (https://edsoo.ru/constructor/). </p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>Давайте рассмотрим возможные пути реализации данной темы в учебном процессе. </p>"
                        }
                    ]
                }
            ]
        },
        {
            order: 2,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации",
            imagePath: "",
            id: "1",
            videoUrl: "./video/video.mp4",
            contentBefore: [{
                type: "text",
                text: `<p>Вторая половина XIX - начало XX века в России – это время формирования национальной интеллигенции, создания литератур народов России, в которых, по словам Льва Николаевича Толстого, «есть полное, всестороннее сознание его (народа), … должна отразиться народная любовь к добру и правде».</p>
                        <p>Решающую роль в просвещении народов сыграла русская литература. Она стала тем маяком, который осветил путь народам, населяющим Российскую империю. </p>
                        <p>Основоположниками родных литератур стали осетинский поэт Коста Хетагуров, борец за татарский литературный язык Габдулла Тукай, этнограф и фольклорист Бурятии Матвей Хангалов, якутский просветитель и гуманист Алексей Елисеевич Кулаковский, балкарский поэт Кязим Мечиев, башкирский поэт и мыслитель Мифтахетдин Акмулла и многие другие. Каждый из них дорожил родной культурой, положил много сил для сохранения родного языка и национальных традиций.</p>
                        <p>Во многом благодаря первопроходцам в создании родной литературы на языках народов Российской Федерации сегодня «Портал национальных литератур» (https://rus4all.ru/) насчитывает, помимо русского, 59 языков, на которых в нашей стране создаются литературные произведения.</p>
                        <p>В последние годы подготовлены сборники, которые не имеют аналогов ни в отечественном, ни в мировом книгоиздании. Это созданные за последнюю четверть века произведения, вошедшие в антологию поэзии современной литературы народов России, которая включает в себя оригиналы поэтических произведений 229 авторов на 57 национальных языках, и антологию прозы современной литературы народов России, которая включает в себя оригиналы прозаических произведений 115 авторов на 50 национальных языках. </p>
                        `
            }],
            contentAfter: [{
                type: "text",
                text: ``
            }]
        },
        {
            order: 4,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1011",
            title: "Практический модуль",
            htmlPath: "./interactive/dist/index.html",
            autoHeight: false
        },
        {
            order: 5,
            nextBtnName: "Далее",
            type: PageType.ADDITIONAL_MATERIALS,
            imagePath: "",
            materials: [
                //   {link: "https://www.youtube.com/embed/CaaH2dUJqf8", title: "Последние загадки Гизы: египетские пирамиды"},
                //  {link: "https://www.youtube.com/embed/Mg7h_qYjs9k", title: "Тайна египетских пирамид Гизы"},
                //  {link: "https://www.youtube.com/embed/MVCTEz-2I0E", title: "Ленские столбы: заповедник"}
            ],
            literatures: [
                "Аминева В.Р. Габдулла Тукай и русская литература ХIX века: типологические параллели. Казань: Татар. кн. изд-во, 2016.",
                "Габдулла Тукай | Габдулла Тукайга багышланган. URL: http://gabdullatukay.ru/  (дата обращения: 17.07.2023).",
                "Коста Хетагуров. URL: http://hetagurov.ru/tvorchestvo/poezia/poemy/  (дата обращения: 16.07.2023).",
                "Критарова Ж.Н. Диалог литератур и судеб: Габдулла Тукай и Алихан Токати // Габдулла Тукай в культурном пространстве ХХ–XXI вв.: материалы международной научно-практической конференции, посвящённой 135-летию со дня рождения классика татарской литературы Г. Тукая / сост.: Л.Р. Надыршина, Ф.Х. Миннуллина, А.Ф. Ганиева. Казань: ИЯЛИ, 2021.",
                "Критарова Ж.Н. Урок литературы в полиэтнической школе. Пособие для учителя. М.: ФГБНУ «Институт стратегии развития образования Российской академии образования», 2018.",
                "«Портал национальных литератур». URL: https://rus4all.ru/  (дата обращения: 18.07.2023).",
                "Проблемы диалога русской литературы (культуры) с культурами других народов: Сборник научных статей, посвящённый юбилею профессора М.В. Черкезовой. Проблемы диалога русской литературы (культуры) с культурами других народов: сборник научных статей, посвященный юбилею профессора М. В. Черкезовой [ред. Критарова Ж. Н.].  М.: Экон-информ. 2012.  246 с.",
                "Современная литература народов России: Поэзия. Антология. Москва: Издательство: ОГИ, 2017 г",
                "Современная литература народов России: Поэзия. Антология. М.: Издательство: ОГИ, 2018 г",
                "Языковое и литературное образование в современной полиэтнической школе: пути обновления в XXI веке: сборник научных трудов Всероссийской научно-практической конференции к 85-летию профессора Меджи Валентиновны Черкезовой. Москва, 19 октября 2022 г. / под ред. Ж. Н. Критаровой. М.: ФГБНУ «Институт стратегии развития образования РАО», 2022.",
            ],
            sites: [
                ""
            ],
            filesToDownload: [
                {
                    link: "./files/additional.pdf",
                    fileName: "Перечень произведений русской и родных литератур народов России, в\n" +
                        "которых очевидны литературные связи и взаимодействия"
                }
            ]
        }
    ],
};
